import { Button, Card, Modal, Tabs, Form } from 'antd';
import async from 'async';
import _, { values } from 'lodash';
import React from 'react';
import app, { use } from 'xadmin';
import { Loading, C } from 'xadmin-ui';
import { SchemaForm } from 'xadmin-form';
const { confirm } = Modal

const DefaultFormLayout = props => {
  const { children, invalid, handleSubmit, onDelete, schema, submitting } = props
  const { _t } = app.context
  const groupProps = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 18, offset: 5 }
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      {children}
      <Form.Item {...groupProps}>
        <Button type="primary" onClick={handleSubmit} loading={submitting} disabled={invalid}>{_t('Save')}</Button>{' '}
        <Button onClick={() => history.back()}>{_t('Cancel')}</Button>
      </Form.Item>
    </Form>
  )
}

const isPermission = (user, view) => {
  return user.permissions.indexOf(view)
}

const deleteUserItem = (newSchema, userForm, field) => {
  delete newSchema.properties[field]
  userForm.forEach((val, index) => {
    if (val == field) userForm.splice(index, 1)
    if (val?.key == field) userForm.splice(index, 1)
  })
  return newSchema
}

const TabsForm = props => {
  const {
    location, router, query, data, forceTabs, loadTbas,
    title, schema, model, mode, loading, saveItem, deleteItem,
    componentClass, baseTitle, style, loadData, schemaKey, ...formProps
  } = use('model.item', props)
  const getQueryKey = props?.getQueryKey
  const [activeKey, setKey] = React.useState(() => {
    const tab = query?.tab || 'base'
    // 清除路由参数
    if (schemaKey == 'model.schema') {
      const url = window.location.href.split("?")[0]
      tab == 'base' && history.replaceState(null, null, url);
    }
    return tab
  })
  const [tabs, setTabs] = React.useState([])
  const formDirty = React.useRef(false)
  let baseModel = (schema || model)

  let flowUtil;
  let calculatorToString;
  try {
    flowUtil = app.get('flowUtil')
    calculatorToString = flowUtil?.calculatorToString
  } catch (error) {

  }

  // React.useEffect(() => {
  //   setKey(query?.tab || 'base')
  // }, [ query ])

  const setTabKey = key => {
    if (activeKey != key) {
      formDirty.current = false
      setKey(key)
      router && router.replace(location.pathname + '?tab=' + key)
    }
  }

  const onChange = (k) => {
    if (!_.isEmpty(getQueryKey) && _.isFunction(getQueryKey)) getQueryKey(k)
    if (_.includes(window.location?.hash, '/app/cmdb')) {
      if (k === 'schema') {
        // 属性设置重新请求数据
        // loadData(formProps?.id, true)
        app.go('/app/cmdb' + '?tab=' + k)
      } else {
        app.go('/app/cmdb')
      }
    }


    if (!formDirty.current) {
      setTabKey(k)
    } else {
      confirm({
        title: '有数据未保存！',
        content: '离开将导致未保存数据丢失，是否确认离开',
        onOk() {
          setTabKey(k)
        },
        onCancel() { },
      })
    }
  }

  const TabSchemaForm = ({ schema, onSubmitSuccess, onSubmit, baseModel }) => {
    return ({ data = {}, saveItem, deleteItem, component, tabActiveKey }) => {
      const onDefaultSunmit = values => {
        // 如果是表单base，则根据生成form的schema对获取的values进行过滤
        // 避免在添加其他tab信息保存后，点击基本页面保存会覆盖其他tab已修改的值
        const baseFormField = schema?.properties ? Object.keys(schema?.properties) : []
        const baseValues = _.pick(values, [...baseFormField, 'id'])

        if (schema?.name == 'warning') {
          let newValues = values?.rules?.length ? values.rules.map(item => {
            if (item?.delay && !_.isNumber(item.delay)) {
              item = {
                ...item,
                delay: calculatorToString && item.delay?.bind ? calculatorToString(item.delay, true) : item.delay,
                delaySetting: item?.delay
              }
            }
            return item
          }) : []
          values = { ...values, rules: newValues }
        }
        return saveItem(schema.name == 'base' ? baseValues : { id: data.id, [schema.name]: values })
      }
      const onFormSubmit = values => {
        if (onSubmit && _.isFunction(onSubmit)) {
          return onSubmit(values, tabActiveKey)
        } else {
          return onDefaultSunmit(values)
        }
      }
      return <SchemaForm
        data={data}
        schema={schema}
        onDelete={deleteItem}
        onSubmitSuccess={onSubmitSuccess}
        component={schema.tabFormComponent || component}
        initialValues={schema.name == 'base' ? data : (data[schema.name] || {})}
        onSubmit={onFormSubmit}
        subscription={{ submitting: true, pristine: true, dirtySinceLastSubmit: true, errors: true, submitErrors: true }}
        {...baseModel.formProps}
      />
    }
  }

  React.useEffect(() => {
    const { schemaKey, id, model, onSubmitSuccess } = props
    const onSubmit = props?.onSubmit
    if (baseModel) {
      async.map(
        [
          {
            ...baseModel, name: 'base',
            title: baseTitle || '基本信息'
          },
          ...((id || forceTabs) || loadTbas ? app.load_list(schemaKey) : [])
        ],
        (item, cb) => {
          const convert = schema => (schema && schema.name) ? ({
            parentTab: schema.parentTab || undefined,
            key: schema.name,
            name: schema.title,
            renderComponent: schema.renderComponent || TabSchemaForm({ schema, onSubmitSuccess, onSubmit, baseModel })
          }) : null;
          if (_.isFunction(item)) {
            item({ model, data: data || {} }, (err, schema) => {
              cb(null, convert(schema));
            });
          } else {
            cb(null, convert(item));
          }
        },
        (err, tabs) => {
          if (err) {
            app.error(err)
            return;
          }
          //存在parentTab 就合并tab 
          const parent_arr = tabs.filter(tab => tab && tab.parentTab)
          const parent_obj = parent_arr.reduce((prev, cur) => {
            prev[cur.parentTab] = parent_arr.filter(tab => tab && tab.parentTab == cur.parentTab)
            return prev
          }, {})
          const parentTabs = Object.keys(parent_obj).map(tab => ({
            key: tab, name: tab,
            renderComponent: () => (<Tabs tabPosition={(mode == 'left' || 'right') ? 'top' : 'left'}>
              {React.useMemo(() => {
                return parent_obj[tab].map(({ name, key, renderComponent: TabComponent }) => (
                  <Tabs.TabPane tab={name} key={key} style={{ minHeight: 400 }}>
                    <TabComponent {...props} data={data} baseModel={baseModel}
                      saveItem={saveItem}
                      deleteItem={deleteItem}
                      tabActiveKey={key}
                      component={props => {
                        React.useEffect(() => props.form.subscribe(({ dirty, modifiedSinceLastSubmit }) => {
                          formDirty.current = modifiedSinceLastSubmit
                        }, { dirty: true, modifiedSinceLastSubmit: true }), [])
                        return <FormLayout {...props} />
                      }}
                    />
                  </Tabs.TabPane>
                ))
              }, [parent_obj[tab]])
              }
            </Tabs>)
          }))
          setTabs([...tabs.filter(tab => tab && !tab.parentTab), ...parentTabs])
        }
      )
    }
  }, [data, baseModel])

  const FormLayout = componentClass || DefaultFormLayout;

  const tabsComponent = React.useMemo(() => {
    let result = tabs
    // tab按照要求排序
    if (_.isArray(props.tabsNameList)) {
      result = []
      props.tabsNameList.forEach(name => {
        let t = tabs.filter(item => item.name === name)?.[0]
        if (t) result.push(t)
      })
    }

    return result && result.length > 0 && result.map(({ name, key, renderComponent: TabComponent }) => {
      return (
        <Tabs.TabPane tab={name} key={key}>
          <TabComponent {...props} baseModel={baseModel}
            saveItem={saveItem}
            deleteItem={deleteItem}
            tabActiveKey={key}
            component={props => {
              React.useEffect(() => props.form.subscribe(({ dirty, modifiedSinceLastSubmit }) => {
                formDirty.current = modifiedSinceLastSubmit
              }, { dirty: true, modifiedSinceLastSubmit: true }), [])
              return <FormLayout {...props} />
            }}
            data={data}
          />
        </Tabs.TabPane>
      )
    })
  }, [tabs])

  const content = (
    <Card style={style} className="TabsForm">
      <Tabs
        tabPosition={mode || 'top'}
        activeKey={activeKey}
        onChange={onChange}
        tabBarExtraContent={[]}
      >
        {tabsComponent}
      </Tabs>
    </Card>
  )

  return loading ? <Loading>{content}</Loading> : content
}


export default TabsForm
